<div #map [id]="mapID" class="esk-style-renderer-window"></div>
